import { t } from "ttag";

import { Layout } from "@/shared/ui";

interface QuestionNavigationProps {
  onBack?: VoidFunction;
  nextLabel?: string;
  nextType?: "submit" | "button";
  onNext?: VoidFunction;
  disabled?: boolean;
}

/**
 * Sticky next/back navigation footer for questionnaire steps. Rendered through
 * Layout.Footer so it stays pinned to the bottom of the viewport.
 */
export const QuestionNavigation = ({
  onBack,
  nextLabel = t`Continue`,
  nextType = "submit",
  onNext,
  disabled,
}: QuestionNavigationProps) => (
  <Layout.Footer>
    {onBack && (
      <Layout.Cancel type="button" onClick={onBack}>
        {t`Back`}
      </Layout.Cancel>
    )}

    <Layout.Action type={nextType} onClick={onNext} disabled={disabled}>
      {nextLabel}
    </Layout.Action>
  </Layout.Footer>
);
